export enum StoreTypename {
  UI = 'Store.Ui',
  USER = 'User',
  TOUR = 'ToursSetting',
  RESOURCES = 'Resources',
  USER_CLASSROOM = 'User Classroom',
  UNIT = 'Unit',
  DOMAIN = 'Domain',
  CHECKLIST = 'Checklist',
  CURRICULUM_ASSESSMENTS = 'Classroom Assessments',
  STUDENT_ASSESSMENT_SUMMARY = 'Student Assessment Summary',
  STUDENT_ASSESSMENT_SCORES = 'Student Assessment Scores',
  EDUCATOR_PACKET = 'Educator Packet',
}

export enum Settings {
  WELCOME = 'welcome',
}

export const FULL_SCREEN = 'FULL_SCREEN';

export enum AssessmentTabs {
  BENCHMARK = 'Benchmark',
  UNIT = 'Unit',
  CHECKLIST = 'Checklist',
}
